import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { getAuthUser, getLoginAs, isAuthenticated } from './auth';

export const PrivateRoute = () => {
    const navigate = useNavigate();
    const showLoginAsBanner = getLoginAs()
    const user = getAuthUser()

    React.useEffect( () => {
      if( !isAuthenticated() )   {
          navigate('/login')
      }
    }, [])

    if( !isAuthenticated() ) return '' 

    return(
        <>
            {!!showLoginAsBanner && (
                <div className="text-center bg-warning   p-0" style={{lineHeight:'15px'}}>
                   <small style={{fontSize:"12px"}}> {showLoginAsBanner.auth_name} is logged in As {user.loginAs.name}</small>
                </div>
            )}
            <Outlet />
        </>
    )
}

export default PrivateRoute;